import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es una dieta restrictiva?',
    a: 'No. Es un sistema estructurado que crea déficit sin extremos.'
  }, {
    q: '¿Necesito ir al gimnasio?',
    a: 'No. Incluye rutinas en casa de 20 minutos.'
  }, {
    q: '¿Funciona si trabajo muchas horas?',
    a: 'Sí. Está diseñado para personas ocupadas.'
  }, {
    q: '¿Cuánto peso puedo perder?',
    a: 'Muchas personas pierden hasta 4–5 kg en 30 días, dependiendo de su punto inicial y compromiso.'
  }, {
    q: '¿Es digital?',
    a: 'Sí. Acceso inmediato tras la compra.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 px-4 bg-white" data-id="element-90">
      <div className="max-w-3xl mx-auto" data-id="element-91">
        <div className="text-center mb-12" data-id="element-92">
          <h2 className="text-4xl font-black text-gray-900 mb-4" data-id="element-93">
            Preguntas frecuentes
          </h2>
          <div className="w-24 h-1 bg-red-600 mx-auto" data-id="element-94"></div>
        </div>

        <div className="space-y-4" data-id="element-95">
          {faqs.map((faq, index) => <div key={index} className="border-2 border-gray-200 rounded-xl overflow-hidden transition-all duration-200" data-id="element-96">
              <button onClick={() => toggleFAQ(index)} className="w-full flex justify-between items-center p-6 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-97">
                <span className="text-xl font-bold text-gray-900" data-id="element-98">{faq.q}</span>
                {openIndex === index ? <ChevronUpIcon className="w-6 h-6 text-red-600 flex-shrink-0" data-id="element-99" /> : <ChevronDownIcon className="w-6 h-6 text-gray-400 flex-shrink-0" data-id="element-100" />}
              </button>

              {openIndex === index && <div className="p-6 bg-white border-t border-gray-200" data-id="element-101">
                  <p className="text-lg text-gray-700" data-id="element-102">{faq.a}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}